import Axios from '../../axios'

export async function getCurrentPoolData () {
  const response = await Axios.get('/nora642')
  return response
}
